/**
 * Hook genérico para Desbloqueio de Confiança.
 * Executa direto (sem modal) usando CPF do perfil.
 * Usado por integrações que não são Hubsoft.
 */
import { useCallback } from 'react';
import { useToast } from '@chakra-ui/react';
import { useProfile } from '@/contexts/ProfileProvider';
import { requestDesbloqueioConfianca } from '../services/desbloqueioConfianca.api';

const TOAST_SUCCESS = {
  title: 'Confiança desbloqueada com sucesso, aguarde o contato do nosso atendimento',
  status: 'success' as const,
  duration: 9000,
  isClosable: true,
};

const TOAST_ERROR = (message: string) => ({
  title: message || 'Erro ao desbloquear confiança',
  status: 'error' as const,
  duration: 9000,
  isClosable: true,
});

export function useDesbloqueioConfianca() {
  const profile: { data?: { cpf?: string } } = useProfile();
  const toast = useToast();

  const executeDesbloqueioConfianca = useCallback(async () => {
    try {
      await requestDesbloqueioConfianca({ cpf: profile?.data?.cpf });
      toast(TOAST_SUCCESS);
    } catch (error: any) {
      toast(TOAST_ERROR(error?.response?.data?.error));
    }
  }, [profile?.data?.cpf, toast]);

  return { executeDesbloqueioConfianca };
}
